import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import nickelTourActions from 'redux/actions/nickelTourActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NickelTourView from 'views/my_library/overlays/nickel_tour/nickel_tour_overlay'
import { myLibrarySelectors } from 'redux/selectors'

class NickelTourContainer extends PureComponent {

	componentDidMount() {
		this.props.actions.initialize()
	}

	render() {
		if (this.props.shouldHideNotification) {
			return null
		}

		return (
			<NickelTourView
				close={this.props.actions.close}
				complete={this.props.actions.complete}
			/>
		)
	}
}

function mapStateToProps(state) {
	return myLibrarySelectors.myLibraryNickelTourSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		initialize: nickelTourActions.initialize,
		close: nickelTourActions.close,
		complete: nickelTourActions.complete,
	}, dispatch)
}

NickelTourContainer.propTypes = {
	actions: PropTypes.shape({
		initialize: PropTypes.func,
		close: PropTypes.func,
		complete: PropTypes.func,
	}),
	shouldHideNotification: PropTypes.bool.isRequired,
}

NickelTourContainer.defaultProps = {
	actions: {
		initialize: () => {},
		close: () => {},
		complete: () => {},
	},
}

export default connect(mapStateToProps, mapDispatchToProps)(NickelTourContainer)
